import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';

import Layout from './pages/Layout';
import Api from './pages/Api';
import Home from './pages/Home';
import BuyingGuide from './pages/learn/buyingGuide/Index';
import About from './pages/learn/About';
import CustomerStories from './pages/learn/CustomerStories';
import PressRoom from './pages/learn/PressRoom';
import AboutMySafe from './pages/aboutMySafe/Index';
import AboutMySafeSearch from './pages/aboutMySafe/Search';
import AboutMySecuritySafes from './pages/aboutMySafe/SecuritySafes';
import WhereToBuy from './pages/whereToBuy/Index';
import WhereToBuyIntl from './pages/whereToBuy/International';
import ProductDetail from './pages/product/ProductDetail';
import ProductCompare from './pages/productCompare/Index';
import ProductSearchLanding from './pages/productSearch/ProductSearchLanding';
import NotFound from './pages/notFound/NotFound.js';
import SiteSearch from './pages/sitesearch/SiteSearch.js';
import CheckSerialNumber from './pages/support/checkSerialNumber.js';
import SiteMap from './pages/siteMap/Index';
import BlackFriday from './pages/lock-it-in/Index';

import SafeSelector from './pages/safeSelector/Index';
import SafeSelectorCapacity from './pages/safeSelector/Capacity';
import SafeSelectorLockType from './pages/safeSelector/LockType';
import SafeSelectorProtection from './pages/safeSelector/Protection';
import SafeSelectorResults from './pages/safeSelector/Results';

import ContactUsUSACanada from './pages/support/contactUs/ContactUsUSACanada';
import ContactUsLanding from './pages/support/contactUs/ContactUsLanding';
import ContactUsUnitedKingdom from './pages/support/contactUs/ContactUsUnitedKingdom.js';
import ContactUsAustralia from './pages/support/contactUs/ContactUsAustralia.js';
import ContactUsThankYou from './pages/support/contactUs/ContactUsThankYou.js';

import Support from './pages/support/Index';
import FindModelSerialNumber from './pages/support/findModelSerialNumber/Index';
import Faqs from './pages/support/faqs/Index';
import HowDoIChangeBatteries from './pages/support/faqs/HowDoIChangeBatteries';
import Videos from './pages/support/videos/Index';
import Email from './pages/support/videos/email/Index';
import ProductManuals from './pages/support/productManuals/Index';
import LostKeyCombo from './pages/support/lostKeyCombo/LostKeyCombo';
import ReplacementProcess from './pages/support/lostKeyCombo/ReplacementProcess';

import FireCategory from './pages/category/FireCategory';
import CashCategory from './pages/category/CashCategory';
import PistolCategory from './pages/category/PistolCategory';
import SecurityCategory from './pages/category/SecurityCategory';
import FireWaterproofCategory from './pages/category/FireWaterproofCategory';
import DocumentCategory from './pages/category/DocumentCategory';
import PortableCategory from './pages/category/PortableCategory';
import BusinessCategory from './pages/category/BusinessCategory';

import StyleGuide from './pages/styleguide/Index';

import * as categoryActions from './actions/categoryActions';
import * as productActions from './actions/productActions';
import * as authActions from './actions/authActions';
import * as faqActions from './actions/faqActions';
import * as supportActions from './actions/supportActions';
import * as siteSearchActions from './actions/siteSearchActions';
import * as homeActions from './actions/homeActions';
import * as cacheActions from './actions/cacheActions';
import tree from "./state";
import FireAndWaterSafes from './pages/learn/FireAndWaterSafes';

export default function () {
	/*
				<Route path="product/:sku" getComponent={({ params }, cb) => {
				productActions.getProductAction(params.sku).then(() => {
					cb(null, ProductDetail);
				}).catch(() => {
					cb(null, NotFound);
				});
			}}

	 */
	return (
		<Route path="/" component={Layout} onEnter={authActions.enterAuthAction}>
			<IndexRoute component={Home} onEnter={homeActions.enterHomeAction} />
			<Route path="cache-clear" component={Api} onEnter={cacheActions.clearCacheAction} />
			<Route path="products" component={ProductSearchLanding} onEnter={productActions.enterProductSearch} />
			<Route path="products/:category" component={ProductSearchLanding} onEnter={productActions.enterProductSearch} />
			<Route path="learn/buying-guide" component={BuyingGuide} />
			<Route path="learn/about-us" component={About} />
			<Route path="learn/customer-stories" component={CustomerStories} />
			<Route path="learn/press-room" component={PressRoom} />
			<Route path="learn/fire-and-water-safes" component={FireAndWaterSafes} />
			<Route path="where-to-buy" component={WhereToBuy} />
			<Route path="where-to-buy-intl" component={WhereToBuyIntl} />
			<Route path="lock-it-in" component={BlackFriday} />
			<Route path="product/:sku" component={ProductDetail} onEnter={
				({ params, location }, replace, callback) => {
					// make sure start clean
					tree.set('product', null);

					// get from API
					productActions.getProductAction(params.sku).then(() => {
						// console.log("got product");
						callback();
					}).catch(() => {
						// console.log("not found");
						callback();
					});
				}} />

			<Route path="product-compare/:skus" component={ProductCompare} onEnter={productActions.enterProductCompare} />

			// Featured product categories
			<Route path="/fire-safes" component={FireCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/cash-boxes" component={CashCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/pistol-safes" component={PistolCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/security-safes" component={SecurityCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/fire-waterproof-safes" component={FireWaterproofCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/document-safes" component={DocumentCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/portable-safes" component={PortableCategory} onEnter={categoryActions.enterCategoryAction} />
			<Route path="/business-safes" component={BusinessCategory} onEnter={categoryActions.enterCategoryAction} />

			<Route path="support" component={Support} onEnter={supportActions.enterSupportAction} />
			<Route path="/support/faqs" component={Faqs} onEnter={faqActions.enterFaqAction} />
			<Route path="/support/faqs/how-do-i-change-the-batteries-on-my-safe" component={HowDoIChangeBatteries} />

			<Route path='/support/lost-key-combo' component={LostKeyCombo} />
			<Route path="/support/lost-key-combo/:country" component={ReplacementProcess} onEnter={supportActions.getLostKeyComboAction} />

			<Route path="/support/videos" component={Videos} onEnter={supportActions.getSupportVideos} />
			<Route path="/support/videos/:id" component={Videos} onEnter={supportActions.getSupportVideos} />

			{/* <Route path="/support/videos/products" component={Videos} onEnter={
				nextState => {
					nextState.location.state = {
						title: 'Product Support',
						tag: 'Products'
					};
				}
			} />
			<Route path="/support/videos/self-help" component={Videos} onEnter={
				nextState => {
					nextState.location.state = {
						title: 'Self Help',
						tag: 'Self-Help'
					};
				}
			} /> */}
			<Route path="/support/videos/email/:id" component={Email} onEnter={
				nextState => {
					nextState.location.state = {
						title: 'Self Help',
						tag: 'Self-Help'
					};
				}
			} />

			<Route path="support/product-manuals" component={ProductManuals} />
			<Route path="support/product-manuals/:sku" component={ProductManuals} onEnter={supportActions.enterProductManualAction} />
			<Route path="support/find-your-model-or-serial-number" component={FindModelSerialNumber} />
			<Route path="support/check-serial-number" component={CheckSerialNumber} />

			<Route path='support/contact-us' component={ContactUsLanding} onEnter={supportActions.enterContactUsAction} />
			<Route path='support/contact-us/united-states-canada' component={ContactUsUSACanada} onEnter={supportActions.enterContactUsAction} />
			<Route path='support/contact-us/united-kingdom' component={ContactUsUnitedKingdom} onEnter={supportActions.enterContactUsAction} />
			<Route path='support/contact-us/australia' component={ContactUsAustralia} onEnter={supportActions.enterContactUsAction} />
			<Route path='support/contact-us/thankyou' component={ContactUsThankYou} />

			<Route path='search' component={SiteSearch} onEnter={siteSearchActions.enterSiteSearchAction} />

			<Route path="site-map" component={SiteMap} />
			<Route path="about-my-safe" component={AboutMySafeSearch} />
			<Route path="about-my-safe/search" component={AboutMySafeSearch} />
			<Route path="about-my-safe/security-safes" getComponent={({ params }, cb) => {
				productActions.getProductAction("X125ML").then(() => {
					cb(null, AboutMySecuritySafes);
				})
			}} />
			<Route path="about-my-safe/:sku" getComponent={({ params }, cb) => {

				const security_safes_list = ['X041E', 'X055', 'X055ML', 'X125', 'X125ML'];
				security_safes_list.includes(params.sku) ? (
					productActions.getProductAction("X125ML").then(() => {
						cb(null, AboutMySecuritySafes);
					})

				) : (
					productActions.getProductAction(params.sku).then(() => {
						cb(null, AboutMySafe);
					}).catch(() => {
						cb(null, ProductManuals);
					})
				)

			}} />

			{/*<Route path="safe-selector" component={SafeSelector} />*/}
			{/*<Route path="safe-selector/capacity" component={SafeSelectorCapacity} onEnter={productActions.enterProductSelector} />*/}
			{/*<Route path="safe-selector/lock-type" component={SafeSelectorLockType} onEnter={productActions.enterProductSelector} />*/}
			{/*<Route path="safe-selector/protection" component={SafeSelectorProtection} onEnter={productActions.enterProductSelector} />*/}
			{/*<Route path="safe-selector/results" component={SafeSelectorResults} />*/}
			{/*<Route path="styleguide" component={StyleGuide} />*/}

			<Redirect from='AboutMySafe' to='/about-my-safe' />
			<Redirect from='AboutMySafeSearch' to='/about-my-safe/Search' />
			<Redirect from='AboutMySafeSupport' to='/about-my-safe/Support' />
			<Redirect from='AfterFireReplacement' to='/learn/buying-guide' />
			<Redirect from='alarm_safe' to='/learn/buying-guide' />
			<Redirect from='Alarm_Safe' to='/learn/buying-guide' />
			<Redirect from='Alarm_Safe/Setup' to='/support/faqs' />
			<Redirect from='Chests_And_Files' to='/products/fire-safes' />
			<Redirect from='Chests_And_Files/Fire' to='/products/fire-safes' />
			<Redirect from='Chests_And_Files/Life' to='/products/fire-safes' />
			<Redirect from='Chests_And_Files/Water' to='/products/fire-safes' />
			<Redirect from='check-your-safe' to='/support/check-serial-number' />
			<Redirect from='ContactUs/CallOrEmailUs' to='/support' />
			<Redirect from='ContactUs/Call_Or_Email_Us' to='/support' />
			<Redirect from='ContactUs/Testimonials' to='/learn/customer-stories' />
			<Redirect from='CustomerCare' to='/support' />
			<Redirect from='CustomerCare/' to='/support' />
			<Redirect from='CustomerCare/Buy_Safe_Accessories' to='/products' />
			<Redirect from='CustomerCare/FAQ' to='/support/faqs' />
			<Redirect from='CustomerCare/FAQs/Files.aspx' to='/support/faqs' />
			<Redirect from='CustomerCare/FAQs/General-Product-Information.aspx' to='/support/faqs' />
			<Redirect from='CustomerCare/FAQs/General-Sentry-Information.aspx' to='/support/faqs' />
			<Redirect from='CustomerCare/FAQs/Gun-Safes.aspx' to='/support/faqs' />
			<Redirect from='CustomerCare/FAQs/Keys.aspx' to='/support/faqs#i-lost-my-key-or-combination' />
			<Redirect from='CustomerCare/FAQs/Media-Storage-Products.aspx' to='/support/faqs#how-we-test-our-products' />
			<Redirect from='CustomerCare/FAQs/Misc.aspx' to='/support/faqs#batteries' />
			<Redirect from='CustomerCare/FAQs/Need-Help-Opening-Your-Safe.aspx' to='/support/faqs#i-need-help-opening-safe' />
			<Redirect from='CustomerCare/FAQs/Safes.aspx' to='/support/faqs' />
			<Redirect from='CustomerCare/FAQs/UL-Product-Classifications.aspx' to='/support/faqs#how-we-test-our-products' />
			<Redirect from='CustomerCare/FAQs/Warranties-And-Guarantees.aspx' to='/support/faqs#warranties-and-guarantees' />
			<Redirect from='CustomerCare/Find_Your_Model_Serial' to='/support/find-your-model-or-serial-number' />
			<Redirect from='CustomerCare/Find_Your_Safe' to='/products' />
			<Redirect from='CustomerCare/Product_Manuals' to='/support/product-manuals' />
			<Redirect from='CustomerCare/Self-Help-Videos' to='/support/videos' />
			<Redirect from='CustomerCare/Self-Help-Videos/' to='/support/videos' />
			<Redirect from='CustomerCare/Where_To_Buy' to='/where-to-buy' />
			<Redirect from='Cyber_Monday' to='/' />
			<Redirect from='how_fire_resistant_safe_works' to='/products/fire-safes' />
			<Redirect from='hurricane_sandy_beginagain' to='/learn/customer-stories' />
			<Redirect from='mobile' to='/' />
			<Redirect from='Products/15/F2300*' to='/support/product-manuals' />
			<Redirect from='Products/166/0500*' to='/product/0500' />
			<Redirect from='Products/169/MS0100*' to='/support/product-manuals' />
			<Redirect from='Products/188/OA3810*' to='/support/product-manuals' />
			<Redirect from='Products/19/H3100*' to='/support/product-manuals' />
			<Redirect from='Products/20/H3300*' to='/support/product-manuals' />
			<Redirect from='Products/224/H4300*' to='/support/product-manuals' />
			<Redirect from='Products/252/X031*' to='/product/X031' />
			<Redirect from='Products/263/X055*' to='/product/X055' />
			<Redirect from='Products/264/X075*' to='/product/X075' />
			<Redirect from='Products/266/X105*' to='/product/X105' />
			<Redirect from='Products/267/X125*' to='/product/X125' />
			<Redirect from='Products/270/HD2100*' to='/product/HD2100' />
			<Redirect from='Products/271/HD4100*' to='/product/HD4100' />
			<Redirect from='Products/286/UC-025K*' to='/product/UC-025K' />
			<Redirect from='Products/287/UC-039K*' to='/product/UC-039K' />
			<Redirect from='Products/288/DH-074E*' to='/product/DH-074E' />
			<Redirect from='Products/289/DH-109E*' to='/product/DH-109E' />
			<Redirect from='Products/290/DH-134E*' to='/product/DH-134E' />
			<Redirect from='Products/316/ESB-3*' to='/product/ESB-3' />
			<Redirect from='Products/317/KDS-1*' to='/product/KDS-1' />
			<Redirect from='Products/387/http//www.walmart.ca' to='/product/P005C' />
			<Redirect from='Products/387/P005C*' to='/product/P005C' />
			<Redirect from='Products/388/http//www.walmart.ca' to='/product/P008E' />
			<Redirect from='Products/388/P008E*' to='/product/P008E' />
			<Redirect from='Products/391/P005K*' to='/product/P005K' />
			<Redirect from='Products/394/http//www.walmart.ca' to='/product/X041E' />
			<Redirect from='Products/394/X041E*' to='/product/X041E' />
			<Redirect from='Products/396/DSW5840*' to='/support/product-manuals' />
			<Redirect from='Products/419/PL048E*' to='/product/PL048E' />
			<Redirect from='Products/421/EF3428E*' to='/product/EF3428E' />
			<Redirect from='Products/422/EF4738E*' to='/product/EF4738E' />
			<Redirect from='Products/454/T0-331*' to='/product/T0-331' />
			<Redirect from='Products/455/T8-331*' to='/product/T8-331' />
			<Redirect from='Products/456/T6-331*' to='/product/T6-331' />
			<Redirect from='Products/457/SFW123CS*' to='/product/SFW123CS' />
			<Redirect from='Products/461/SFW123ES*' to='/product/SFW123ES' />
			<Redirect from='Products/475/H060ES*' to='/product/H060ES' />
			<Redirect from='Products/476/HL100ES*' to='/product/HL100ES' />
			<Redirect from='Products/485/KSW0510*' to='/support/product-manuals' />
			<Redirect from='Products/491/1200*' to='/product/QAP1E' />
			<Redirect from='Products/496/QAP1E*' to='/product/QAP1E' />
			<Redirect from='Products/496/www.homedepot.com' to='/product/QAP1E' />
			<Redirect from='Products/497/DSW3950*' to='/support/product-manuals' />
			<Redirect from='Products/503/QAP1BE*' to='/product/QAP1BE' />
			<Redirect from='Products/505/SFW205CXB*' to='/support/product-manuals' />
			<Redirect from='Products/506/SFW205FYC*' to='/product/SFW205FYC' />
			<Redirect from='Products/518/CHW20201*' to='/product/CHW20201' />
			<Redirect from='Products/521/FHW40120*' to='/product/FHW40120' />
			<Redirect from='Products/522/FHW40200*' to='/product/FHW40200' />
			<Redirect from='Products/526/PP1K*' to='/product/PP1K' />
			<Redirect from='Products/528/SFW123TTC*' to='/product/SFW123TTC' />
			<Redirect from='Products/534/SFW205TWC*' to='/product/SFW205TWC' />
			<Redirect from='Products/535/SFW205TXC*' to='/product/SFW205TXC' />
			<Redirect from='Products/540/CHW30100*' to='/product/CHW30100' />
			<Redirect from='Products/74/CB-8*' to='/product/CB-8' />
			<Redirect from='Products/75/CB-10*' to='/product/CB-10' />
			<Redirect from='Products/76/CB-12*' to='/product/CB-12' />
			<Redirect from='Products/77/CB-14*' to='/support/product-manuals' />
			<Redirect from='Products/78/DS-1*' to='/product/DS-1' />
			<Redirect from='Products/79/DCB-1*' to='/product/DCB-1' />
			<Redirect from='Products/8/1170*' to='/product/1170' />
			<Redirect from='Products/82/KB-25*' to='/product/KB-25' />
			<Redirect from='Products/83/KB-50*' to='/product/KB-50' />
			<Redirect from='Series/1/Chests' to='/products/fire-waterproof-safes' />
			<Redirect from='Series/10/Home_Defense' to='/products/pistol-safes' />
			<Redirect from='Series/2/Personal_Files' to='/products/document-safes' />
			<Redirect from='Series/3/Fire_Resistant_Safes' to='/products/fire-safes' />
			<Redirect from='Series/7/Portable_Security' to='/products/portable-safes' />
			<Redirect from='Series/8/Cash_Handling' to='/products/cash-boxes' />
			<Redirect from='Series/9/Security_Safes' to='/products/security-safes' />
			<Redirect from='University/Glossary' to='/learn/buying-guide' />
			<Redirect from='University/Glossary/' to='/learn/buying-guide' />
			<Redirect from='University/Safes101' to='/learn/buying-guide' />
			<Redirect from='Cart/shopping_Cart' to='/' />

			<Redirect from='/buying-guide' to='/learn/buying-guide' />

			// pdf tab
			<Redirect from='/pdfs/OwnersManuals/IntBarracudal.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401267.pdf' to='/support/product-manuals' />
			<Redirect from='/promotions/Molded/pdfs/SentrySafe_Child_Keepsakes_List.pdf' to='/products/water-and-fireproof-safes' />
			<Redirect from='/promotions/Molded/pdfs/SentrySafe_Newly_Married_To_Do_List.pdf' to='/products/water-and-fireproof-safes' />
			<Redirect from='/promotions/Molded/pdfs/SentrySafe_New_Home_Security_Checklist.pdf' to='/products/water-and-fireproof-safes' />
			<Redirect from='/promotions/Molded/pdfs/SentrySafe_Buying_A_New_Home.pdf' to='/products/water-and-fireproof-safes' />
			<Redirect from='/promotions/Molded/pdfs/SentrySafe_Wedding_Keepsakes_List.pdf' to='/products/water-and-fireproof-safes' />
			<Redirect from='/pdfs/OwnersManuals/401587.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/518030.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/400437.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401186.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/400562.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401574.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401164.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/517862.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401149.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/513022.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401845.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/518792.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/516113.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/518162.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401163.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401799.pdf' to='/support/product-manuals' />
			<Redirect from='/promotions/Molded/pdfs/SentrySafe_Perfect_Baby_Keepsake_Box.pdf' to='/products/water-and-fireproof-safes' />
			<Redirect from='/pdfs/OwnersManuals/401147.pdf' to='/support/product-manuals' />
			<Redirect from='/pdfs/OwnersManuals/401038.pdf' to='/support/product-manuals' />

			<Route path="*" component={NotFound} />
		</Route >
	);
}


// WEBPACK FOOTER //
// ./src/routes.js